import { PostLineModel } from "../schema/post-line.model";
import { MongoBaseContainer } from "./mongo-base-container.model";

export class PostLineContainer extends MongoBaseContainer{
    post_line: PostLineModel
}